var _mask, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2903_617",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9.5C11.4853 9.5 13.5 7.48528 13.5 5C13.5 2.51472 11.4853 0.5 9 0.5C6.51472 0.5 4.5 2.51472 4.5 5C4.5 7.48528 6.51472 9.5 9 9.5ZM2 15C2 13.8954 2.89543 13 4 13H14C15.1046 13 16 13.8954 16 15V19.5H2V15ZM0 15C0 12.7909 1.79086 11 4 11H14C16.2091 11 18 12.7909 18 15V21.25C18 21.3881 17.8881 21.5 17.75 21.5H0.25C0.111929 21.5 0 21.3881 0 21.25V15Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.5V21.5H18V19.5H16ZM2 19.5H0V21.5H2V19.5ZM11.5 5C11.5 6.38071 10.3807 7.5 9 7.5V11.5C12.5899 11.5 15.5 8.58985 15.5 5H11.5ZM9 2.5C10.3807 2.5 11.5 3.61929 11.5 5H15.5C15.5 1.41015 12.5899 -1.5 9 -1.5V2.5ZM6.5 5C6.5 3.61929 7.61929 2.5 9 2.5V-1.5C5.41015 -1.5 2.5 1.41015 2.5 5H6.5ZM9 7.5C7.61929 7.5 6.5 6.38071 6.5 5H2.5C2.5 8.58985 5.41015 11.5 9 11.5V7.5ZM4 11C1.79086 11 0 12.7909 0 15H4V11ZM14 11H4V15H14V11ZM18 15C18 12.7909 16.2091 11 14 11V15H18ZM18 19.5V15H14V19.5H18ZM2 21.5H16V17.5H2V21.5ZM0 15V19.5H4V15H0ZM4 9C0.686292 9 -2 11.6863 -2 15H2C2 13.8954 2.89543 13 4 13V9ZM14 9H4V13H14V9ZM20 15C20 11.6863 17.3137 9 14 9V13C15.1046 13 16 13.8954 16 15H20ZM20 21.25V15H16V21.25H20ZM17.75 23.5C18.9926 23.5 20 22.4927 20 21.25H16C16 20.2835 16.7835 19.5 17.75 19.5V23.5ZM0.25 23.5H17.75V19.5H0.25V23.5ZM-2 21.25C-2 22.4927 -0.99263 23.5 0.25 23.5V19.5C1.21649 19.5 2 20.2835 2 21.25H-2ZM-2 15V21.25H2V15H-2Z",
    fill: "url(#paint0_linear_2903_617)",
    mask: "url(#path-1-inside-1_2903_617)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2903_617",
    x1: 9,
    y1: 0.5,
    x2: 9,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99479C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#51008B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#301C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#090029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120049"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.bdb32c4a5b23aaab3136f29e9785cd8f.svg";
export { ForwardRef as ReactComponent };